export default {
  "nav.spreadsheet": "Arkusz USFans",
  "nav.reviews": "Opinie",
  "nav.shipping": "Wysyłka",
  "nav.guides": "Poradniki",
  "nav.safety": "Bezpieczeństwo",
  "nav.faq": "FAQ",
  "nav.cta": "Przeglądaj arkusz",
  "nav.home": "Strona główna",
  "nav.shoppingGuide": "Przewodnik zakupowy",

  "hero.eyebrow": "CENTRUM ZASOBÓW USFANS",
  "hero.h1": "Arkusz USFans — znajdź, porównaj i odkrywaj zasoby USFans",
  "hero.subtitle": "Szukasz prostszego sposobu na przeglądanie arkuszy USFans, informacji o produktach, zasobów sprzedawców, poradników QC i informacji o wysyłce? USFansLink łączy przydatne zasoby USFans w jednym uporządkowanym, przeszukiwalnym centrum.",
  "hero.ctaPrimary": "Przeglądaj arkusz USFans",
  "hero.ctaSecondary": "Przeczytaj poradnik USFans",
  "hero.trust": "Niezależne źródło • Regularnie aktualizowane • Stworzone dla łatwiejszych badań",
  "hero.cardBadge": "Arkusz USFans",
  "hero.cardTitle": "Uporządkowane centrum zasobów",
  "hero.cardText": "Przeglądaj kategorie, porównuj poradniki i przechodź od razu do potrzebnych produktów.",

  "buttons.usfans": "arkusz usfans",
  "buttons.buyNow": "Kup teraz",

  "categories.title": "Przeglądaj według kategorii",
  "categories.subtitle": "Wybierz kategorię poniżej i przejdź od razu do potrzebnych produktów na naszej głównej stronie.",
  "categories.placeholder": "Wybierz kategorię",
  "categories.go": "Przejdź do kategorii",

  "cat.shoes": "Buty",
  "cat.hoodies": "Bluzy / Swetry",
  "cat.tshirts": "Koszulki",
  "cat.jackets": "Kurtki",
  "cat.pants": "Spodnie / Szorty",
  "cat.headwear": "Nakrycia głowy",
  "cat.sets": "Zestawy",
  "cat.underwear": "Bielizna / Majtki",
  "cat.jersey": "Koszulki sportowe",
  "cat.accessories": "Akcesoria",
  "cat.bags": "Torby",
  "cat.belts": "Paski",
  "cat.perfumes": "Perfumy",
  "cat.other": "Inne rzeczy",

  "value.title": "Wszystko, czego potrzebujesz do badania USFans w jednym miejscu",
  "value.subtitle": "Uporządkowane, praktyczne zasoby, które pomogą Ci ocenić informacje przed podjęciem decyzji.",
  "value.card1.title": "Arkusz USFans",
  "value.card1.text": "Poznaj uporządkowane zasoby arkusza i naucz się oceniać informacje przed podjęciem decyzji.",
  "value.card2.title": "Opinie USFans",
  "value.card2.text": "Zrozum kluczowe czynniki, które warto sprawdzić podczas badania USFans i powiązanych usług.",
  "value.card3.title": "Informacje o wysyłce",
  "value.card3.text": "Dowiedz się, jak mogą się różnić koszty, metody, opcje dostawy i potencjalne opłaty.",
  "value.card4.title": "Zasoby QC",
  "value.card4.text": "Zrozum zdjęcia kontroli jakości, szczegóły produktów i typowe rzeczy, które kupujący powinni zweryfikować.",
  "value.card5.title": "Centrum bezpieczeństwa",
  "value.card5.text": "Naucz się rozpoznawać podejrzane linki, chronić konta i oceniać zewnętrzne strony internetowe.",

  "featured.title": "Poznaj arkusz USFans",
  "featured.text": "Użyj naszego zasobu arkusza USFans jako punktu wyjścia do badań. Porównuj informacje, przeglądaj powiązane poradniki i odkrywaj praktyczne zasoby bez skakania po rozproszonych stronach.",
  "featured.cta": "Zobacz arkusz USFans",

  "review.title": "Opinie USFans: co warto sprawdzić?",
  "review.text": "Przed skorzystaniem z jakiejkolwiek usługi zakupów lub pozyskiwania produktów online warto sprawdzić reputację, dostępne informacje, opcje wysyłki, procesy magazynowe, praktyki płatności i bezpieczeństwo konta. Nasze poradniki wyjaśniają, na co zwracać uwagę, aby podjąć bardziej świadomą decyzję.",
  "review.cta": "Przeczytaj poradnik opinii USFans",

  "shipping.title": "Przewodnik po kosztach wysyłki USFans",
  "shipping.text": "Koszty wysyłki mogą się różnić w zależności od miejsca docelowego, rozmiaru paczki, wagi, metody wysyłki i innych czynników. Dowiedz się, jak porównywać opcje wysyłki i rozumieć pokazywane informacje przed złożeniem zamówienia.",
  "shipping.cta": "Poznaj przewodnik wysyłki",

  "safety.title": "Czy USFans jest legalny? Sprawdź, na co zwrócić uwagę",
  "safety.text": "Szukasz „USFans legit”? Nie polegaj na pojedynczej opinii ani wpisie w mediach społecznościowych. Naucz się oceniać adresy URL, strony płatności, bezpieczeństwo konta, informacje o sprzedawcy, linki zewnętrzne i inne sygnały zaufania.",
  "safety.cta": "Przeczytaj przewodnik bezpieczeństwa USFans",

  "article.title": "Najnowszy poradnik USFans",
  "article.text": "Nasz oryginalny, szczegółowy przewodnik po arkuszu USFans wyjaśnia, czym jest, jak go używać, co sprawdzić przed zakupem i na jakie punkty bezpieczeństwa zwrócić uwagę.",
  "article.cta": "Przeczytaj pełny przewodnik",

  "final.title": "Gotowy na odkrywanie zasobów USFans?",
  "final.text": "Zacznij od arkusza USFans, przeglądaj najnowsze poradniki i korzystaj z informacji, które najlepiej pasują do Twoich potrzeb.",
  "final.ctaPrimary": "Przeglądaj arkusz USFans",
  "final.ctaSecondary": "Odwiedź główną stronę",

  "pillars.eyebrow": "Poradniki USFans",
  "pillars.title": "Główne poradniki USFans",
  "pillars.subtitle": "Szczegółowe, oryginalne poradniki obejmujące arkusz USFans, wysyłkę, bezpieczeństwo, kontrolę jakości, kupony i wiele więcej.",
  "pillars.readMore": "Czytaj więcej",

  "footer.tagline": "Niezależne centrum zasobów, które łączy przydatne zasoby USFans w jednym uporządkowanym miejscu.",
  "footer.disclosure": "Niezależnie prowadzone źródło informacji. Nie jest oficjalnie powiązane z USFans.",
  "footer.explore": "Odkrywaj",
  "footer.resources": "Zasoby",
  "footer.navHome": "Strona główna",
  "footer.navGuide": "Przewodnik po arkuszu USFans",
  "footer.navCategories": "Kategorie",
  "footer.rights": "Wszelkie prawa zastrzeżone."
};